import { Reveal, SectionLabel } from "../Reveal";
import { SPONSORSHIP } from "../../data/content";
import { ArrowUpRight } from "lucide-react";

export const Sponsorship = () => {
  const go = () => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
  return (
    <section id="sponsorship" className="relative py-24 sm:py-32 md:py-40 bg-[#050505] bg-noise border-t border-white/10 overflow-hidden" data-testid="sponsorship-section">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#BAF173] opacity-10 blur-[140px] pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
        <SectionLabel>{SPONSORSHIP.label}</SectionLabel>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <Reveal>
              <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold uppercase tracking-tight text-white leading-[0.95]">
                {SPONSORSHIP.heading}
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-7 text-base sm:text-lg text-white/65 leading-relaxed">{SPONSORSHIP.pitch}</p>
            </Reveal>
            <Reveal delay={0.2}>
              <button data-testid="sponsor-cta-btn" onClick={go} className="mt-9 inline-flex items-center gap-2 font-display text-sm font-semibold uppercase tracking-widest px-8 py-4 bg-[#BAF173] text-black hover:bg-[#a5db65] hover:scale-[1.02] transition-all duration-300">
                Request Media Kit <ArrowUpRight size={18} />
              </button>
            </Reveal>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {SPONSORSHIP.offers.map((o, i) => (
              <Reveal key={o.title} delay={i * 0.1}>
                <div className="border border-white/10 bg-black p-7 h-full group hover:border-[#BAF173]/50 transition-colors" data-testid="sponsor-offer">
                  <span className="font-display text-5xl font-bold text-white/10 group-hover:text-[#BAF173]/30 transition-colors">{String(i + 1).padStart(2, "0")}</span>
                  <h3 className="font-display text-xl font-semibold uppercase tracking-wide text-white mt-3 mb-2">{o.title}</h3>
                  <p className="text-sm text-white/55 leading-relaxed">{o.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
